// removed by extract-text-webpack-plugin
module.exports = {"header":"header__1dYe8ZD6Gqmu","button":"button__2Luro5EAYLdx"};